<template>
    <div class="form-row">
        <div class="form-group col-md-3 mb-0" >
            <select v-model="selectedBulkAction" class="form-control "  style="max-width:200px; margin-bottom:15px;" @change="actionChange()">
                <option hidden>Action</option>
				<option>View Summary</option>
                <option>Schedule mail</option>
            </select>
        </div>
		<SalesSummary @resetAction = "resetAction"></SalesSummary>
    </div>
</template>

<script>

import SalesSummary from '@/components/sales-diagnostic/SalesSummary'


export default {
    name: 'SalesActions',
    data() {
        return {
			selectedBulkAction:'Action'
        }
    },
	components : {
		SalesSummary
	},
    computed: {

    },
    methods: {
		actionChange(){
			if(this.selectedBulkAction == "View Summary"){
				window.$("#salesSummary").modal({
					show: true
				});
			}
		},
		resetAction(){
			this.selectedBulkAction = 'Action'
		}
    }
}
</script>

<style lang="scss">

</style>
